export const ContentObjective = {
    BRAND_AWARENESS: 'awareness',
    ENGAGEMENT: 'engagement',
    EDUCATION: 'awareness',
    COMMUNITY: 'promotion',
    SALES: 'sales',
    LOYALTY: 'promotion'
};

export const ObjectiveDescriptions = {
    [ContentObjective.BRAND_AWARENESS]: {
        title: 'Visibilidad de Marca',
        description: 'Aumentar el reconocimiento y presencia de tu marca',
        examples: ['Historias de marca', 'Valores empresariales', 'Detrás de escenas']
    },
    [ContentObjective.ENGAGEMENT]: {
        title: 'Interacción con la Audiencia',
        description: 'Generar conversaciones y conexiones con tu comunidad',
        examples: ['Preguntas interactivas', 'Encuestas', 'Contenido participativo']
    },
    [ContentObjective.EDUCATION]: {
        title: 'Educación y Valor',
        description: 'Compartir conocimiento y contenido útil para tu audiencia',
        examples: ['Tips y consejos', 'Tutoriales', 'Guías prácticas']
    },
    [ContentObjective.COMMUNITY]: {
        title: 'Construcción de Comunidad',
        description: 'Fortalecer lazos con tu audiencia y crear sentido de pertenencia',
        examples: ['Historias de clientes', 'Eventos comunitarios', 'Colaboraciones']
    },
    [ContentObjective.SALES]: {
        title: 'Ventas y Promociones',
        description: 'Promocionar productos y ofertas especiales',
        examples: ['Lanzamientos', 'Ofertas especiales', 'Productos destacados']
    },
    [ContentObjective.LOYALTY]: {
        title: 'Fidelización',
        description: 'Mantener y recompensar a tus clientes actuales',
        examples: ['Programas de lealtad', 'Beneficios exclusivos', 'Agradecimientos']
    }
};

// Aunque estamos en JavaScript, definimos las estructuras de datos para documentación
export const ContentProposalStructure = {
    theme: '',
    objective: '',
    targetAudience: '',
    tone: '',
    proposals: [], // Array de PostProposal
    suggestedVariables: {
        productImage: '',
        price: '',
        discount: '',
        cta: ''
    },
    recommendedTemplateId: '',
    strategy: ''
};

export const PostProposalStructure = {
    title: '',
    description: '',
    cta: '',
    hashtags: [],
    bestTimeToPost: '',
    recommendedPlatform: '',
    reasoning: ''
}; 